import React, { useEffect, useState } from "react";

import img2 from "../../image/6.svg";
import img4 from "../../image/8.svg";
import { FaUserAlt } from "react-icons/fa";
import { IoEyeSharp } from "react-icons/io5";
import { PiEyeSlashFill } from "react-icons/pi";
import { FaLock } from "react-icons/fa";
import { useForm } from "react-hook-form";
import Loader from "../Loader/Loader";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { useNavigate } from "react-router-dom";
function Login({ BaseUrl }) {
  const navigate = useNavigate();
  const [eye, seteye] = useState(false);
  const [login, setlogin] = useState(false);
  const Handler_eye = () => {
    seteye(!eye);
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const Handler_login = (data) => {
    setlogin(!login);
    axios
      .post(`${BaseUrl}/Auth/login`, data)
      .then((res) => {
        setlogin(false);
        console.log(res)
        localStorage.setItem("TOKEN", res.data.Token);
        setTimeout(() => {
          navigate("/");
        }, 1000);
      })
      .catch((err) => {
        setlogin(false);
        console.log(err)
        NotificationManager.error(err.response.data.message);
      });
  };
  const Handler_Enter = (e) => {
    const data={
      email:watch('email'),
      password:watch("password")
    }
    if(e.key=="Enter"){
      Handler_login(data)
    }
  };

  return (
    <div
      style={{ direction: "ltr" }}
      class="bg-white flex justify-center items-center h-screen "
    >
      <div class="w-full lg:w-1/2 lg:flex relative hidden h-screen bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">
        <img src={img4} alt="Placeholder Image" class=" w-3/4 h-full m-auto" />
      </div>
      <div
        class="lg:p-36 md:p-52 sm:20 p-8 w-full lg:w-1/2 relative"
        style={{ direction: "rtl" }}
      >
        <img
          src={img2}
          alt="Placeholder Image"
          class=" w-1/4 h-full m-auto mb-4"
        />
        <h1 class="text-2xl font-semibold  text-center mb-10">خوش آمدید</h1>
        <div class="mb-2 relative flex items-center border-b-2 border-gray-300">
          <FaUserAlt className="absolute text-xl mr-2 text-orange-700" />
          <input
           onKeyDown={Handler_Enter}
           style={{ outline: "none !important", border: "none" }}
            placeholder="ایمیل"
            type="email"
            {...register("email", {
              required: "ایمیل الزامی است",
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "ایمیل نامعتبر است",
              },
            })}
            class="w-full focus:outline-none focus:ring-0 focus:border-none bg-white pr-10 py-2 px-3  text-xl "
            autocomplete="off"
          />
        </div>
        <div>
          {errors.email && (
            <p className="text-red-800">{errors.email?.message}</p>
          )}
        </div>
        <div class="mb-2 mt-10 relative flex items-center border-b-2 border-gray-300">
          <FaLock className="absolute text-xl mr-2 text-orange-700" />
          <input
           onKeyDown={Handler_Enter}
            placeholder="رمز عبور"
            style={{ outline: "none !important", border: "none" }}
            type={eye ? "text" : "password"}
            {...register("password", {
              required: "پسورد را وارد کنید",
              minLength: {
                value: 8,
                message: "پسورد نباید کمتر از 8 کاراکتر باشد",
              },
            })}
            class="w-full focus:outline-none focus:ring-0 focus:border-none bg-white pr-10 py-2 px-3  text-xl "
            autocomplete="off"
          />

          {eye ? (
            <PiEyeSlashFill
              className="text-xl text-orange-700 cursor-pointer"
              onClick={Handler_eye}
            />
          ) : (
            <IoEyeSharp
              className="text-xl text-orange-700 cursor-pointer"
              onClick={Handler_eye}
            />
          )}
        </div>
        <div>
          {errors.password && (
            <p className="text-red-800">{errors.password?.message}</p>
          )}
        </div>

        <div className="flex justify-center">
          {login ? (
            <Loader />
          ) : (
            <button
              onClick={handleSubmit(Handler_login)}
              class="w-1/4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-full transition-all duration-200 ease-in py-2 px-4"
            >
              ورود
            </button>
          )}
        </div>
      </div>
      <NotificationContainer />
    </div>
  );
}

export default Login;
